import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const InnerContainer: React.FC<Props> = ({ children }) => {
  return <div className="flex-1 pt-6 pb-6">{children}</div>
}
